import React, { useState, useEffect } from 'react';
import { useLanguage } from 'Context/LanguageContext';
import { getBaseColumsGroupTask, hasGroupTasKFunctionality } from 'FielderUtils/groupTask/groupTaskColumn';
import TaskGroupStatus from '~/Status/TaskGroupStatus';
import groupTaskConst from 'FielderUtils/roleManagementConst/groupTasksConst';
import Delete from '@mui/icons-material/Delete';
import useValidateRoles from '@core/utils/roles/useValidateRoles';
import POPUPNAME from 'FielderUtils/popupName/popupName';
import { Row, Container } from 'react-bootstrap';
import Grid from '@mui/material/Grid2';
import Tooltip from '@mui/material/Tooltip';
import SearchIcon from '@assets/icons/search-icon.svg';
import ResetFilterIcon from '@assets/icons/reset-filter-icon.svg';
import AlertIcon from '@assets/icons/redAlert-icon.svg';
import MyOperationDatePicker from './MyOperationDatePicker';
import Cookies from 'universal-cookie';
import ConfirmationDialog from '../../ConfirmationDialog/ConfirmationDialog';
import PermanenDeleteMessage from '../../PermanenDeleteMessage/PermanenDeleteMessage';
import { useFielderSnackBar } from '~/FielderElements/useFielderSnackBar';
import { SuperAdmin, Admin, Manager } from 'FielderUtils/roles/roles';
import MainTable from 'OldComponents/MainTable';
import { useSelector } from 'react-redux';
import { selectUser, selectSession } from '@core/store/modules/session/sessionSelectors';
import {
  getTaskGroupsRequest, getTaskGroupRealTimeRequest, disableTaskGroupRequest
} from '@core/api/task/task.group.service';
import 'FielderUtils/style.css';
import Switch from '~/Switch/Switch.component';
import RoleUtils from 'FielderUtils/roles/roleUtils';
import CreateGroupTask from '@assets/icons/create-group-tasks.svg';
import Divider from '@mui/material/Divider';
import Loading from '~/FielderElements/Loading/Loading';

var moment = require('moment-timezone');
let selectedRows = [];
const cookieUpdateTaskGroup = new Cookies();
const cookieUpdateTaskGroupPreference = 'UpdateTaskGroupPreferences';

export default function TaskGroupTab(props) {
	const user = useSelector(selectUser);
  const session = useSelector(selectSession);
	const lan = useLanguage();
  const fielderMsg = useFielderSnackBar();
	const [offset, setOffset] = useState(0);
	const [columns, setColumns] = useState(getBaseColumsGroupTask());
	const [rows, setRows] = useState([]);
	const { isRoleValid } = useValidateRoles();
	const [numberOfElements, setNumberOfElements] = useState(10);
	const [canDeleteGroupTask, setCanDeleteGroupTask] = useState(isRoleValid(groupTaskConst.GROUPTASK, groupTaskConst.DELETE))
	const [tooltips, setTooltips] = useState([]);
	const [timeTo, setTimeTo] = useState(null);
	const [filter, setFilter] = useState(null);
	const [executeLoadMore, setExecuteLoadMore] = useState(false);
	const [hasMore, setHasMore] = useState(true);
  const [from, setFrom] = useState(null);
  const [to, setTo] = useState(null);
  const [datesError, setDatesError] = useState(false);
  const [daypickers, setDaypickers] = useState({ daypickerone: false, daypickertwo: false });
  const [sizeTaskGroup, setSizeTaskGroup] = useState(0);
  const [showTaskGroupUpdates, setShowTaskGroupUpdates] = useState(false);
  const [confirmationDialogGroupTask, setConfirmationDialogGroupTask] = useState(false);
  const [messageConfirmDeleteGroupTasks, setMessageConfirmDeleteGroupTasks] = useState(lan.messageConfirmDeleteGroupTasks);
  const [listOfErrorDeleteGroupTask, setListOfErrorDeleteGroupTask] = useState([]);
  const [numberSuccess, setNumberSuccess] = useState(0);
  const [numberLinked, setNumberLinked] = useState(0);
  const [errormessageDelete, setErrormessageDelete] = useState(false);
  const [refreshSelected, setRefreshSelected] = useState(false);
  const canCreateGroupTasks = isRoleValid(groupTaskConst.GROUPTASK, groupTaskConst.CREATE, session.roles);
  const canViewTaskGroups = isRoleValid(groupTaskConst.GROUPTASK, groupTaskConst.VIEW, session.roles);
  const groupTaskFunctionality = hasGroupTasKFunctionality(session.account.funcionalityPurchases);
  const [showLoading, setShowLoading] = useState(true);
  const changeLoadingFilter = (value) => setShowLoading(value);
  useEffect(() => {
    loadMore();
  }, [to, from, filter, executeLoadMore]);
	useEffect(() => {
		selectedRows = [];
	}, [refreshSelected]);
	useEffect(() => {
		if (props.rowToAddTaskGroup != null) addRow(props.rowToAddTaskGroup);
	}, [props.rowToAddTaskGroup]);
	useEffect(() => {
		if (props.rowToUpdateTaskGroup != null) updateRow(props.rowToUpdateTaskGroup);
	}, [props.rowToUpdateTaskGroup]);
	useEffect(() => {
		if (props.rowToUpdateStatusTaskGroup != null) updateRowStatus(props.rowToUpdateStatusTaskGroup);
	}, [props.rowToUpdateStatusTaskGroup]);
	useEffect(() => {
		if (canDeleteGroupTask) {
			setTooltips([
				{
					title: lan.deleteGroupTaskTooltip,
					action: () => {deleteGroupTask()},
					icon: <Delete />,
				},
			])
		}
	}, []);
  useEffect(() => {
    if (cookieUpdateTaskGroup.get(cookieUpdateTaskGroupPreference) !== undefined) {
      const show = JSON.parse(cookieUpdateTaskGroup.get(cookieUpdateTaskGroupPreference));
      setShowTaskGroupUpdates(show);
    }
  }, []);
	const addRow = (rowToAdd) => {
		const allRows = rows;
		const { idGroup } = rowToAdd;
		let willAddRow = true;
		for (let i = 0; i < allRows.length; i++) {
			if (allRows[i].idGroupTask === idGroup) {
				willAddRow = false;
				break;
			}
		}
		if (willAddRow) {
			const body = {
				idGroup: idGroup
			};
			const onSuccess = ({ group }) => {
				if (group != null) {
					if (
            filter == null &&
            showTaskGroupUpdates &&
            to == null
					) {
						allRows.unshift(groupTaskToRow(group));
						setRows(allRows);
						addNumberOfElementsTaskGroup();
					} else props.addNotificationCountRealGroup();
				}
			};
			getTaskGroupRealTimeRequest(body, onSuccess);
		}
	};
	const updateRow = (rowToUpdate) => {
		const allRows = rows;
		const { idGroup } = rowToUpdate;
		if (showTaskGroupUpdates) {
			let updateRow = false;
			for (let i = 0; i < allRows.length; i++) {
				if (allRows[i].idGroupTask === idGroup) {
					var index = i;
					updateRow = true;
					break;
				}
			}
			const body = { idGroup: idGroup };
			const onSuccess = ({ group }) => {
				if (group != null) {
					const continueUpdatedRow = validateRowToUpdate(group);
					if (updateRow && continueUpdatedRow) {
						allRows[index] = groupTaskToRow(group);
						setRows([...allRows]);
					} else {
						allRows.unshift(groupTaskToRow(group));
						setRows([...allRows]);
					}
				}
			};
			getTaskGroupRealTimeRequest(body, onSuccess);
		} else props.addNotificationCountRealGroup();
	}
	const updateRowStatus = (rowToUpdate) => {
		const allRows = rows;
		const { idGroup } = rowToUpdate;
		if (showTaskGroupUpdates) {
			let updateRow = false;
			for (let i = 0; i < allRows.length; i++) {
				if (allRows[i].idGroupTask === idGroup) {
					var index = i;
					updateRow = true;
					break;
				}
			}
			if (updateRow) {
				const body = { idGroup: idGroup };
				const onSuccess = ({ group }) => {
					if (group != null) {
						allRows[index] = groupTaskToRow(group);
						setRows([...allRows]);
					}
				};
				getTaskGroupRealTimeRequest(body, onSuccess);
			}
		} else props.addNotificationCountRealGroup();
	}
	const validateRowToUpdate = (group) => {
		if (user && (user.role === SuperAdmin.name || user.role === Admin.name) && user.idAccount === group.idAccount) {
			return true;
		} else if (user && user.role === Manager.name && user.idTeams.includes(group.idTeam)) {
			return true;
		} else if (user && (user.role === SuperAdmin.name || user.role === Admin.name ) &&
      user.idAccount === group.idPartner ) return true;
		return false;
	}
	const loadMore = () => {
		changeLoadingFilter(true);
		let offsetGroupTask = offset;
    if (timeTo !== to || executeLoadMore) {
      offsetGroupTask = 0;
      setHasMore(true);
    }
    let fromDate = from ? from.getTime() : null;
    if (from == null) {
      let newDate = new Date();
      newDate.setMonth(newDate.getMonth() - 3);
      fromDate = newDate.getTime();
    }
    let toDate = to ? to.setHours(23, 59, 59) : null;
    if (to == null) {
      let newDate = new Date();
      newDate.setMonth(newDate.getMonth() + 3);
      toDate = newDate.getTime();
    }
    const body = {
      filter: filter,
      offset: offsetGroupTask,
      limit:10,
      fromDate: fromDate,
      toDate: toDate,
      activeGroupTask: true,
    };
		const onSuccess = ({ groupTask, count }) => {
			changeLoadingFilter(false);
			if (groupTask.length > 0) {
				//showNotGroupTask = false;
				setOffset(offsetGroupTask + 10);
				const newRows = rowsReducer(groupTask);
				if (newRows.concat === true) {
					let stateRow = rows;
					stateRow = stateRow.concat(newRows.newRows);
					setRows([...stateRow]);
				} else setRows([...newRows.newRows]);
			}
			if (count === 0) {
				const resetRows = [];
				setRows([...resetRows]);
				setHasMore(false);
			}
			setElementsGroupTask(count);
      setTimeTo(to);
      setExecuteLoadMore(false);
		};
		const onError = (e) => {
			changeLoadingFilter(false);
		}
		getTaskGroupsRequest(body, onSuccess, onError);
	}
	const tableCookie = {
		tableCookieName: 'taskGroupTable',
		colOrderCookieName: 'taskGroupTableColOrder',
		cookie: new Cookies(),
	};
	const rowsReducer = (groupTask) => {
		const newRows = groupTask ? groupTask.map(groupTaskToRow) : [];
		let concat = true;
		if (groupTask.length < numberOfElements) setHasMore(false);
    if (timeTo !== to || executeLoadMore) concat = false;
    return { concat, newRows };
	}
  const getFilterTaskTab = (text) => {
    let tags = [];
    let filters = '';
    if (text) {
      const splited = text.split(' ');
      for (let i = 0; i < splited.length; i++) {
        const fltr = splited[i];
        if (fltr.includes('#')) tags.push(fltr.slice(1));
        else filters = filters + ' ' + fltr;
      }
    }
    if (tags.length === 0) tags = null;
    if (filters === '') filters = null;
    return { filter: filters, tags };
  };
  const showDayPickerInput = (name) => {
    setDaypickers({ ...daypickers, [name]: !daypickers[name] });
  };
  const handleFromDate = (date) => {
    setFrom(date);
  };
  const handleToDate = (date) => {
    if (from && date && date.getTime() < from.getTime()) {
      setDatesError(true);
      setTo(null);
      return;
    }
    setDatesError(false);
    setTo(date);
    setExecuteLoadMore(!executeLoadMore);
  };
  const resetDateValues = () => {
    setFrom(null);
    setTo(null);
  };
  const handlerEventKey = (e) => {
    if (e.charCode === 13) handleFilter();
  };
  const handleFilter = () => {
    if (to && !from) {
      setDatesError(true);
      return;
    }
    if (from && !to) {
      setDatesError(true);
      return;
    }
    setDatesError(false);
    const input = document.getElementById('tf-filter');
    let localFilter = null;
    if (input && input.value !== '') {
      const { filter: f, tags } = getFilterTaskTab(input.value.trim());
      localFilter = f;
    }
    setFilter(localFilter);
    setExecuteLoadMore(!executeLoadMore);
  };
  const handleResetFilter = () => {
    const input = document.getElementById('tf-filter');
    if (input) input.value = '';
    setFilter(null);
    setExecuteLoadMore(!executeLoadMore);
  };
	const groupTaskToRow = (taskGroup) => {
		return {
			idGroupTask: taskGroup.id,
			idCustomGroup: taskGroup.idCustomGroup,
			name: taskGroup.name,
			executionDate: taskGroup.executionDateTime
				? moment(taskGroup.executionDateTime).format('DD-MM-YYYY hh:mm a')
				: '',
			branch: taskGroup.branch ? taskGroup.branch.name : '',
			taskGroupStatusLowerCase: <TaskGroupStatus taskGroup={taskGroup} />,
			idAccount:taskGroup.idAccount
		}
	};
	const reorderModify = () => {
		if (rows != null && rows.length > 0) {
			const trueFirst = rows.sort((a, b) =>
        Number(b.modifyTaskStatusComment) - Number(a.modifyTaskStatusComment));
			setRows([...trueFirst]);
		}
	};
  const setElementsGroupTask = (count) => setSizeTaskGroup(count);
  const addNumberOfElementsTaskGroup = () => setSizeTaskGroup(sizeTaskGroup + 1);
  const handleTaskGroupShowUpdates = (checked) => {
    cookieUpdateTaskGroup.set(cookieUpdateTaskGroupPreference, checked, { path: '/' });
    setShowTaskGroupUpdates(checked);
    selectedRows = [];
    setRefreshSelected(!refreshSelected);
  };
  const showMessageDelete = () => setErrormessageDelete(false);
  const getSelectedIdGroupTask = (rowsSel) => {
    const ids = [];
    if (rowsSel && rowsSel.length) {
      for (let i = 0; i < rowsSel.length; i++) {
        if (rowsSel[i].idGroupTask) ids.push(rowsSel[i].idGroupTask);
      }
    }
    return ids;
  };
  const getSelectedIdGroupTaskInfo = (rowsSel) => {
    const ids = [];
    let canDelete = true;
    if (rowsSel && rowsSel.length) {
      for (let i = 0; i < rowsSel.length; i++) {
        if (rowsSel[i].idAccount !== session.user.idAccount) canDelete = false;
        if (rowsSel[i].idGroupTask) ids.push(rowsSel[i].idGroupTask);
      }
    }
    return { idSelected: ids, canDelete };
  };
  const disableGroupTask = (idGroupTask, i, idGroupTasks, numLinked, numSuccess, list) => {
    if (i < idGroupTasks.length) {
      const body = { idGroup: idGroupTasks[i] };
      const onSuccess = () => {
        numSuccess += 1;
        list.push({ idGroupTask, statusCode: 0 });
      };
      const onError = ({ status }) => {
        numLinked += 1;
        list.push({ idGroupTask, statusCode: status });
      };
      disableTaskGroupRequest(body, onSuccess, onError).then(() => {
        i += 1;
        disableGroupTask(idGroupTasks[i], i, idGroupTasks, numLinked, numSuccess, list);
      });
    } else {
      selectedRows = [];
      setConfirmationDialogGroupTask(false);
      setListOfErrorDeleteGroupTask(list);
      setNumberSuccess(numSuccess);
      setNumberLinked(numLinked);
      setErrormessageDelete(true);
      setRefreshSelected(!refreshSelected);
      setExecuteLoadMore(!executeLoadMore);
    }
  };
  const handlerActionDisableGroupTasks = () => {
    const ids = getSelectedIdGroupTask(selectedRows);
    const list = [];
    disableGroupTask(ids[0], 0, ids, 0, 0, list);
  };
  const deleteGroupTask = () => {
    if (selectedRows.length > 0) {
      const info = getSelectedIdGroupTaskInfo(selectedRows);
      if (info.canDelete) {
        setMessageConfirmDeleteGroupTasks(lan.messageConfirmDeleteGroupTasks);
        setConfirmationDialogGroupTask(true);
      } else {
        fielderMsg({
          title: lan.myOperation, message: lan.messageTaskGroupDeletePartner,
          variant: 'error', closeButton: true, duration: 7000 });
      }
    } else {
      fielderMsg({
        title: lan.myOperation, message: lan.messageEmptyGroupTasks,
        variant: 'error', closeButton: true, duration: 7000 });
    }
  };
  const closeDeleteConfirmationDialogGroupTask = () => {
    setConfirmationDialogGroupTask(false);
    selectedRows = [];
    setRefreshSelected(!refreshSelected);
  };
  const resetGroupTaskSectionView = () => {
    setRefreshSelected(!refreshSelected);
  };
	const onRowClickButton = (taskGroup) => props.onRowClickButtonAction(POPUPNAME.EDIT_GROUP_TASK, taskGroup);
	const onCheckboxClick = (selectedRow, selectAll) => {
		if (selectedRow != null) {
			const { idGroupTask } = selectedRow;
			let addValue = true;
			for (let i = 0; i < selectedRows.length; i++) {
				if (selectedRows[i].idGroupTask === idGroupTask) {
					if (!selectAll) selectedRows.splice(i, 1);
					addValue = false;
				}
			}
			if (addValue) selectedRows.push(selectedRow);
		} else selectedRows = [];
		if (selectedRows.length > 0) {
			props.handleCheckTaskGroupTab(selectedRows);
		} else props.handleCheckTaskGroupTab(selectedRows);
	};
	return (
		<Container fluid style={{ overflow: 'none' }}>
      <Grid container spacing={2} className='mx-2' alignItems='center'>
        <Grid size={{ xs: 6, lg: 6 }} className={datesError ? 'Fielder-input-border-alert ml-4' : 'Fielder-input-border ml-4'}>
          <MyOperationDatePicker
            from={from}
            handleFromDate={handleFromDate}
            to={to}
            handleToDate={handleToDate}
            minTime={new Date().setHours(8, 0)}
            showDayPickerInput={showDayPickerInput}
            resetDateValues={resetDateValues}
          />
          {datesError && (
            <img src={AlertIcon} alt='' id='taskType-alert-icon' className='MyOperation-alert-icon'></img>
          )}
        </Grid>
        <Grid size={'auto'} sx={{ ml: 2 }}>
          <Tooltip title={lan.disableAvacedSearch} placement='top'>
            <Grid container alignItems='center' className='Fielder-input-border'>
              <React.Fragment>
                <Grid className='col-auto pl-1 pr-0 mt-2'>
                  <img onClick={handleFilter} src={SearchIcon} className='icon cursor-pointer' alt='' />
                </Grid>
                <Grid size={8}>
                  <input className='myoperation-input-select filter-color-hover mt-2 text-left'
                         id='tf-filter' onKeyPress={handlerEventKey} />
                </Grid>
              </React.Fragment>
              {filter != null && (
                <Grid className='mt-2 no-padding col-auto'>
                  <img onClick={handleResetFilter} src={ResetFilterIcon} className='icon cursor-pointer' alt='' />
                </Grid>
              )}
            </Grid>
          </Tooltip>
        </Grid>
        <Grid size={'auto'} sx={{ ml: 'auto' }}>
          {showLoading ? (
            <Loading inline size='40px' thickness={1} />
          ) : (
            <>
              <span className='myoperation-count-title1'>{lan.groups}</span>
              <span className='myoperation-count-title2'>{sizeTaskGroup}</span>
            </>
          )}
        </Grid>
      </Grid>
      <Divider sx={{ mt:2 }} />
      <Grid container direction="row" sx={{ justifyContent: "space-between", alignItems: "center", p:2 }}>
        <Grid size={'auto'}>
          {!RoleUtils.isUserClient(user) &&
            groupTaskFunctionality &&
            canViewTaskGroups && (
              <Switch
                id='switch-show-updates-task-group'
                value={showTaskGroupUpdates}
                onChange={handleTaskGroupShowUpdates}
                label={lan.showTaskGroupUpdates}
              />
          )}</Grid>
        {canCreateGroupTasks && (
          <Grid size={'auto'}>
            <img
              src={CreateGroupTask}
              id='MyOperation-export-icon'
              className='icon Fielder-icon-button'
              alt='Exportar'
              title={lan.titleIconGroup}
              onClick={() => {
                props.changePopupState(POPUPNAME.CREATE_GROUP_TASK);
                resetGroupTaskSectionView();
              }}
            />
          </Grid>
        )}
      </Grid>
			<Row>
				<MainTable
					InfiniteScroll
					loadMore={loadMore}
					hasMore={hasMore}
					reorderCols={setColumns}
					refreshSelected={refreshSelected}
					cols={columns}
					rows={rows}
					onCheckboxClick={onCheckboxClick}
					onRowClickButton={onRowClickButton}
					disabledDetailButton={false}
					tooltips={tooltips}
					cookie={tableCookie}
					reorderModify={reorderModify}
					stickyHeader
					height={500}
					{...props}
				/>
			</Row>
      {confirmationDialogGroupTask && (
        <ConfirmationDialog
          lan={lan}
          handleAction={handlerActionDisableGroupTasks}
          handleClose={closeDeleteConfirmationDialogGroupTask}
          message={messageConfirmDeleteGroupTasks}
        />
      )}
      {errormessageDelete && (
        <PermanenDeleteMessage
          {...props}
          lan={lan}
          numberSuccess={numberSuccess}
          numberLinked={numberLinked}
          closeErrorMessage={showMessageDelete}
          showErrorMessage
          messageElement={lan.linkedTextAdministratador}
          elementName={lan.groupTask}
        />
      )}
		</Container>
	);
}
